import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import data from '../data/pages.json'
import HtmlParser from 'react-html-parser';
import NotFound from '../pages/NotFound';
import Loading from '../components/Loading';
import Section from '../components/Section'

const Content = () => {
  
  const [page, setPage] = useState();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    setLoading(true);

    const page = data.find(item => item.id === id);
    setPage(page);

    setLoading(false);
  }, [id]);

  if (loading) return(<Loading/>);

  if (!page) return(<NotFound/>);

  return (
    <div>
      <Section title={HtmlParser(page.title)}/>
      <div className='mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32'>
        {HtmlParser(page.html)}
      </div>
    </div>
  )
}

export default Content